module.exports = __webpack_public_path__ + "static/media/node.42d0423a.png";